import { render, staticRenderFns } from "./Step11.vue?vue&type=template&id=164bbcc6&scoped=true"
import script from "./Step11.vue?vue&type=script&lang=js"
export * from "./Step11.vue?vue&type=script&lang=js"
import style0 from "./Step11.vue?vue&type=style&index=0&id=164bbcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164bbcc6",
  null
  
)

export default component.exports